import Cookies from "js-cookie";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";

import { PlatformType } from "graphql/generated";
import { CURRENT_COUNTRY } from "src/constants/Countries";
import { trackingAnonymousId, trackingUserId } from "src/constants/cookie-names.constant";
import { trackSegment } from "src/dataTracking";
import { patientState } from "src/states";
import { uuidGen } from "src/utils";

export const getAnonymousId = () => {
  let anonymousId = Cookies.get(trackingAnonymousId);

  if (!anonymousId) {
    anonymousId = uuidGen();
  }

  Cookies.set(trackingAnonymousId, anonymousId, { expires: 365 });

  return anonymousId;
};

export const trackPageEvent = (
  name: string,
  category: string,
  options: {
    enabled?: boolean;
    platform?: PlatformType;
  } = {}
) => {
  if (typeof window === undefined || options.enabled === false) {
    // Don't track page view on server-side
    return;
  }

  trackSegment({
    segmentType: "page",
    anonymousId: getAnonymousId(),
    name,
    category,
    userId: Cookies.get(trackingUserId),
    properties: {
      platform: options.platform,
      region: CURRENT_COUNTRY
    }
  });
};

export const useTrackPageEvent = (
  name: string,
  category: string,
  options: {
    enabled?: boolean;
  } = {}
) => {
  const patient = useRecoilValue(patientState);
  useEffect(() => {
    trackPageEvent(name, category, {
      enabled: options.enabled,
      platform: patient?.fromPlatformEnv
    });
  }, [name, category, options.enabled, patient]);
};
